import { createContext, useState, useMemo, useRef, useEffect } from "react";

// Create context
export const FiltersContext = createContext();

export const WindowProvider = ({ children }) => {
    const [showFilters, setShowFilters] = useState(false);
    const [isOpenDatabar, setIsOpenDatabar] = useState(false);
    const [handleData, setHandleData] = useState(false);
    const [isCardOpen, setIsCardOpen] = useState({
        touchpoints: false,
        externalData: false,
    });
    const dropdownRefs = {
        touchpoints: useRef(null),
        externalData: useRef(null),
    };

    // Click outside dropdown close
    useEffect(() => {
        const handleClickOutside = (event) => {
            Object.keys(dropdownRefs).forEach((key) => {
                const ref = dropdownRefs[key];
                if (ref.current && !ref.current.contains(event.target)) {
                    setIsCardOpen((prevState) => ({ ...prevState, [key]: false }));
                }
            });
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownRefs]);

    const contextValue = useMemo(() => ({
        isCardOpen,
        dropdownRefs,
        showFilters,
        isOpenDatabar,
        handleData
    }), [isCardOpen, showFilters,dropdownRefs, isOpenDatabar, handleData]);

    const contextActions = useMemo(() => ({
        setIsCardOpen,
        setShowFilters,
        setIsOpenDatabar,
        setHandleData
    }), []);

    return (
        <FiltersContext.Provider value={{ ...contextValue, ...contextActions }}>
            {children}
        </FiltersContext.Provider>
    );
};